import React from 'react';
import Cell from './cell/cell';
import styles from './three-cell.css';

const ThreeCell = ({ cells }) => {
    return (
        <div className={styles.wrapper}>
            {cells.map((cell, index) => {
                return (
                    <Cell key={index} {...cell} />
                );
            })}
        </div>
    );
};

export default ThreeCell;
